import { StyleSheet } from 'aphrodite';

const dropdownWidth = 160;

const styles = StyleSheet.create({
  root: {
    position: 'relative',
    overflow: 'visible',
    display: 'flex',
    fontSize: 12
  },
  dropdownButton: {
    width: dropdownWidth,
    height: 32,
    textAlign: 'left',
    borderRadius: 6,
    paddingLeft: 12,
    fontSize: 12,
    display: 'flex',
    flexDirection: 'row',
    alignContent: 'center',
    position: 'relative',
    background: 'white',
    border: '1px solid rgba(0,0,0,0.12)',
    ':hover': {
      border: '1px solid rgba(0,0,0,0.24)',
      cursor: 'pointer'
    }
  },
  sortIcon: {
    color: 'rgba(0,0,0,0.24)',
    position: 'absolute',
    top: 10,
    right: 10,
    transition: '200ms'
  },
  sortIconExpanded: {
    transform: 'rotate(180deg)'
  },
  optionsContainer: {
    position: 'absolute',
    border: '1px solid rgba(0,0,0,0.12)',
    borderRadius: 6,
    overflow: 'hidden',
    top: 32 + 6,
    left: 0,
    display: 'flex',
    flexDirection: 'column',
    zIndex: 1,
    background: 'white',
    boxShadow: '0px 3px 5px rgba(0,0,0,0.04)'
  },
  option: {
    width: dropdownWidth,
    height: 32,
    display: 'flex',
    flexDirection: 'row',
    paddingLeft: 12,
    alignItems: 'center',
    background: 'white',
    ':hover': {
      background: 'rgba(0,0,0,0.06)',
      cursor: 'pointer'
    }
  }
});

export default styles;



// WEBPACK FOOTER //
// ./src/components/common/dropdown/dropdown-styles.js